import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { Navbar } from "@/components/site/Navbar";
import { Footer } from "@/components/site/Footer";
import { AgeBanner } from "@/components/site/AgeBanner";
import { SmoothScroll } from "@/lib/motion";
import { Toaster } from "@/components/ui/sonner";

export const Layout = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <SmoothScroll>
      <div className="App noise-overlay min-h-screen bg-paper">
        <Navbar />
        <main className="relative z-10">
          <Outlet />
        </main>
        <Footer />
        <AgeBanner />
        <Toaster position="top-center" />
      </div>
    </SmoothScroll>
  );
};
